import { useState } from 'react';

const testimonials = [
  {
    name: '王先生',
    role: '科技業主管',
    quote: '琮恩幫我做了完整的保單健檢，發現我有三張保單重複投保，每年省下將近兩萬元的保費，同時還補強了醫療保障的缺口。他的專業分析讓我對保險有了全新的認識。',
    highlight: '每年省下兩萬元保費',
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20business%20executive%20portrait%20confident%20smile%20formal%20attire%20clean%20white%20background%20studio%20photography&width=400&height=500&seq=test001&orientation=portrait',
  },
  {
    name: '林小姐',
    role: '新婚媽媽',
    quote: '懷孕後才意識到保障的重要性，琮恩非常有耐心地為我和先生規劃了完整的家庭保障方案。從壽險到兒童保險，每一個細節都考慮得非常周全，讓我們安心迎接新生命。',
    highlight: '完整家庭保障規劃',
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20young%20mother%20portrait%20warm%20smile%20elegant%20casual%20attire%20clean%20light%20background%20studio%20photography&width=400&height=500&seq=test002&orientation=portrait',
  },
  {
    name: '張先生',
    role: '自營業主',
    quote: '身為自營業主，我的保障需求比一般上班族複雜很多。琮恩深入了解我的財務狀況後，設計了一套兼顧事業風險與個人保障的方案，讓我可以專心衝刺事業。',
    highlight: '兼顧事業與個人保障',
    img: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20entrepreneur%20business%20owner%20portrait%20confident%20mature%20smile%20smart%20casual%20attire%20clean%20background%20studio%20photography&width=400&height=500&seq=test003&orientation=portrait',
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent((c) => (c + 1) % testimonials.length);

  const t = testimonials[current];

  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#C9A84C] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            CLIENT TESTIMONIALS
          </p>
          <h2
            className="font-serif font-bold text-[#0F2847]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            客戶真實回饋
          </h2>
          <div className="w-16 h-1 bg-[#C9A84C] mx-auto rounded-full mt-4"></div>
        </div>

        {/* Testimonial Card */}
        <div className="bg-[#F8F9FA] rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* Photo */}
            <div className="w-full lg:w-[40%] flex-shrink-0">
              <div className="h-72 lg:h-full min-h-[400px]">
                <img
                  src={t.img}
                  alt={t.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Content */}
            <div className="w-full lg:w-[60%] p-10 lg:p-14 flex flex-col justify-between">
              <div>
                <span className="inline-block bg-[#C9A84C]/15 text-[#C9A84C] px-4 py-1.5 rounded-full font-semibold mb-6" style={{ fontSize: '1rem' }}>
                  {t.highlight}
                </span>

                <h3
                  className="font-serif font-bold text-[#0F2847] mb-6"
                  style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.5' }}
                >
                  「{t.highlight}，感謝琮恩的專業協助」
                </h3>

                <div className="relative">
                  <i className="ri-double-quotes-l text-[#C9A84C]/30 text-6xl absolute -top-4 -left-2"></i>
                  <p
                    className="text-gray-600 relative z-10 pl-4"
                    style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
                  >
                    {t.quote}
                  </p>
                </div>
              </div>

              <div className="mt-10 flex items-center justify-between">
                <div>
                  <p className="font-serif font-bold text-[#0F2847]" style={{ fontSize: '1.1875rem' }}>
                    — {t.name}
                  </p>
                  <p className="text-gray-500 mt-1" style={{ fontSize: '1rem' }}>{t.role}</p>
                </div>

                {/* Controls */}
                <div className="flex items-center gap-3">
                  <button
                    onClick={prev}
                    className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-300 text-gray-500 hover:border-[#0F2847] hover:text-[#0F2847] transition-colors duration-200 cursor-pointer"
                    aria-label="上一則"
                  >
                    <i className="ri-arrow-left-line text-lg"></i>
                  </button>
                  <button
                    onClick={next}
                    className="w-12 h-12 flex items-center justify-center rounded-full bg-[#0F2847] text-white hover:bg-[#1a3d6b] transition-colors duration-200 cursor-pointer"
                    aria-label="下一則"
                  >
                    <i className="ri-arrow-right-line text-lg"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`rounded-full transition-all duration-200 cursor-pointer ${
                i === current ? 'w-8 h-2.5 bg-[#C9A84C]' : 'w-2.5 h-2.5 bg-gray-300 hover:bg-gray-400'
              }`}
              aria-label={`見證 ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
